import { AltaLogo } from 'new-components/svgs/AltaLogo';

import CloudKeyUnlockPage from './pages/CloudKeyUnlockPage/CloudKeyUnlockPage';

import './CloudKeyUnlockApp.scss';

export const CloudKeyUnlockApp = () => {
  return (
    <div className="cloud-key-unlock-app">
      <header>
        <AltaLogo />
      </header>

      <CloudKeyUnlockPage />
    </div>
  );
};
